import type { FC } from 'react';
import { LoopsWrapper } from './Loops.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface LoopsProps {}

const Loops: FC<LoopsProps> = () => (
<LoopsWrapper>	
   <header className="entry-header ">
      <h1 className="entry-title" itemProp="headline">Loops</h1>			
   </header>
   <br/>
   <br/>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify">Below is the list of commonly used loops :</p>
      <h4 className="text-align-justify"><strong>for loop </strong></h4>
      <ul className="text-align-justify">
         <li>A for loop is used when number of iteration is fixed i.e., how many times you want to loop through a block of code.</li>
         <li>Syntax:
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'for (initialization condition; testing condition; increment / decrement) {\n'+
                  '  //block of code\n'+
                  '}'
               }
            </SyntaxHighlighter>
         </li>
         <li>Example:
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'for (int i = 1; i <= 5; i++) {\n'+
                  '  System.out.println(i);\n'+
                  '}'
               }
            </SyntaxHighlighter>
         </li>
      </ul>
      <br />
      <h4 className="text-align-justify"><strong>enhanced for loop</strong></h4>
      <ul className="text-align-justify">
         <li>An enhanced for loop is used to iterate through the elements of a collection or array in sequential manner.</li>
         <li>Syntax:
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'for (Datatype element: Collection / array) {\n'+
                  '  //block of code\n'+
                  '}'
               }
            </SyntaxHighlighter>
         </li>
         <li>Example:
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'for (String s: names) {\n'+
                  '  System.out.println(s);\n'+
                  '}'
               }
            </SyntaxHighlighter>
         </li>
      </ul>
      <br />
      <h4 className="text-align-justify"><strong>while loop</strong></h4>
      <ul className="text-align-justify">
         <li>A while loop is like a repetitive if condition, that loops through a block of code as long as the specified condition is true. </li>
         <li>It is known as entry controlled loop.</li>
         <li>Syntax:
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'while (condition) {\n'+
                  '  //block of code\n'+
                  '}'
               }
            </SyntaxHighlighter>
         </li>
         <li>Example:
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'int i = 1;\n'+
                  'while (i> 5) {\n'+
                  '  System.out.println(i);\n'+
                  '  i++;\n'+
                  '}'
               }
            </SyntaxHighlighter>
         </li>
      </ul>
      <br />
      <h4 className="text-align-justify"><strong>do while loop</strong></h4>
      <ul className="text-align-justify">
         <li>A do while loop is similar to while loop. </li>
         <li>The only difference is that it checks for condition after executing the block of code. </li>
         <li>It is executed at least once. </li>
         <li>It is known as exit controlled loop.</li>
         <li>Syntax:
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'do {\n'+
                  '  // block of code\n'+
                  '} while (condition);'
               }
            </SyntaxHighlighter>
         </li>
         <li>Example:
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
               {
                  'int i = 1;\n'+
                  'do {\n'+
                  '  System.out.println(i);\n'+
                  '  i++;\n'+
                  '} while (i> 5);'
               }
            </SyntaxHighlighter>
         </li>
      </ul>
   </div>
</LoopsWrapper>
);

export default Loops;
